import {showNotification} from "@mantine/notifications";
import {
    AiOutlineExclamation,
    AiOutlineInfo,
    AiOutlineLogin
} from "react-icons/ai";
import {signInWithRedirect} from "aws-amplify/auth";

/** The shape of a GraphQL error response, or of a thrown Error. */
type ServiceError = {
    errors?: { message: string; }[],
    message?: string,
}


export const showErrorNotifications = (exception: unknown) => {

    console.debug('handleAppSyncResponseException', exception)

    const e = exception as ServiceError;
    if (typeof e.errors !== 'undefined' && e.errors.length > 0) {
        e.errors.forEach((error) => {
            showErrorNotification(error.message);
        })
    }
}


export const notifySuccess = (message = 'Record saved successfully') => {
    showNotification({
                         title: 'Success',
                         icon: <AiOutlineInfo/>,
                         message: message,
                         color: 'teal',
                     })
}

export const showErrorNotification = (message = 'Error performing the operation') => {
    showNotification({
                         title: 'Error',
                         icon: <AiOutlineExclamation/>,
                         message: message,
                         color: 'red',
                     })

    const noCurrentUserMessage = 'no current user'
    if (message.toLowerCase() === noCurrentUserMessage) {
        notifySessionExpired();
    }

}

export const notifyError = (exception: unknown) => {

    console.trace(exception);

    const e = exception as ServiceError;
    if (typeof e.errors !== 'undefined' && Array.isArray(e.errors)) {
        e.errors.forEach((error) => {
            showNotification({
                                 title: 'Error',
                                 icon: <AiOutlineExclamation/>,
                                 message: error.message,
                                 color: 'red',
                             });
        })
        return;
    }

    const message = e.message ? e.message : 'Error performing the operation'

    showNotification({
                         title: 'Error',
                         icon: <AiOutlineExclamation/>,
                         message: message,
                         color: 'red',
                     })

    const noCurrentUserMessage = 'no current user'
    if (message.toLowerCase() === noCurrentUserMessage) {
        notifySessionExpired();
    }

}

export const notifySessionExpired = (message = 'Redirecting to login page... Please, wait!') => {

    showNotification({
                         title: 'Session Expired',
                         icon: <AiOutlineLogin/>,
                         message: message,
                         color: 'blue',
                     });

    setTimeout(() => {
        signInWithRedirect();
    }, 2000);

};


// notify access denied
export const notifyAccessDenied = (message = 'Access denied') => {
    showNotification({
                         title: 'Access Denied',
                         icon: <AiOutlineExclamation/>,
                         message: message,
                         color: 'red',
                     })
}